import { useParams } from "react-router-dom";
import DraftList from "./DraftList";
import DraftEditor from "./DraftEditor";

const Drafts = () => {
  const { id } = useParams();
  return id ? <DraftEditor draftId={id} /> : <DraftList />;
};

export default Drafts;
